import React from 'react';
import MathCCAClass6to82025 from 'views/MathCCAClass6to82025';

const MathClubPage = () => {
  return <MathCCAClass6to82025/>;
};

export default MathClubPage;